module.exports = __webpack_public_path__ + "img/38.3.TP.d2bf0b92.png";